import * as z from "zod/v4";

export const updateBrightpearlOmsSettings = {
  name: "updateBrightpearlOmsSettings" as const,
  input: z.object({
    enabled: z.boolean().optional(),
    defaultShippingMethodId: z.number().nullish(),
    shippedStatusId: z.number().nullish(),
  }),
  output: z.object({ success: z.boolean() }),
};
